import { defineComponent as _defineComponent } from 'vue'
import { computed, useContext } from '@nuxtjs/composition-api';
import { JobsJobSearchStatus } from '@/types/graphql';
import Avatar from '@/components/common/Avatar/Avatar.vue';
import BravadoButtonV3 from '@/components/common/BravadoButtonV3/BravadoButtonV3.vue';
import { getPortfolioPath } from '@/utils/routes';
import JobsProfileSection from '@/components/partials/jobs/JobsProfile/JobsProfileSection.vue';
import { BravadoButtonV3Size } from '~/components/common/BravadoButtonV3/types';

type JobsProfileUserProfileProps = {
  jobSearchStatus: JobsJobSearchStatus;
  showUserData: Boolean;
};
type JobsProfileUserProfileEmits = {
  (event: 'edit'): void;
};


export default /*#__PURE__*/_defineComponent({
  __name: 'JobsProfileUserProfile',
  props: {
    jobSearchStatus: null,
    showUserData: null
  },
  emits: ["edit"],
  setup(__props: any, { emit }: { emit: ({
  (event: 'edit'): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  jobSearchStatus: JobsJobSearchStatus;
  showUserData: Boolean;
};



const { $auth, $analytics } = useContext();

const portfolioPath = computed(() => ($auth.user?.slug ? getPortfolioPath($auth.user.slug) : ''));
const hint = computed(() =>
  props.jobSearchStatus === JobsJobSearchStatus.NotInterested
    ? 'Your job search is turned off. You will not hear about new opportunities. Change it in your work preferences anytime.'
    : 'Your portfolio is visible to recruiters. Keep your info updated to get matched with new opportunities.',
);

function handleClickEdit() {
  $analytics?.logEvent('jobs__desired-criteria_edit');

  emit('edit');
}

return { __sfc: true,props, emit, $auth, $analytics, portfolioPath, hint, handleClickEdit, Avatar, BravadoButtonV3, JobsProfileSection, BravadoButtonV3Size }
}

})